import { render, staticRenderFns } from "./SemifinishedProductCombobox.vue?vue&type=template&id=aaaf2b4c&scoped=true&"
import script from "./SemifinishedProductCombobox.vue?vue&type=script&lang=ts&"
export * from "./SemifinishedProductCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./SemifinishedProductCombobox.vue?vue&type=style&index=0&id=aaaf2b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaf2b4c",
  null
  
)

export default component.exports